import requests from "./httpServices";
import {showErrorAlert} from "./AlertService";

const AuthServices = {
    register: async (userdetials) => {
        try {
        const response =await requests.post('/auth/register', userdetials);
        return response;
        }catch(error){
            showErrorAlert(error); 
        }
    },

    schoolregister: async (userdetials) => {
        try{
        const response=await requests.post('/auth/schoolregister', userdetials);
        return response;
        }catch(error){
            console.log(error,"errorr");
            showErrorAlert(error);  
        }
    },

    teacherregister: async (userdetials) => {
        try{
        const response=await requests.post('/auth/teacherregister', userdetials);
        return response;
    }catch(error){
        showErrorAlert(error);  
    }
    },

    login: async (userdetials) => {
        try {
        const response=await requests.post('/auth/login', userdetials);
        return response;
    }catch(error){
        showErrorAlert(error);  
    }
    },

    getSchool: async () => {
        try {
            const response=await requests.get('/auth/getschool');
            return response;
        }catch(error){
            showErrorAlert(error);  
        }

    },
    viewCertificateByUserId: async (param) => {
        try {
            const response=await requests.get(`/auth/certificate/${param.userid}?type=${param.type}`);
            return response;
        }catch(error){
            showErrorAlert(error);  
        }
    },
    forgotPassword: async (userdetials) => {
        try {
            const response=await requests.post('/auth/forgotPassword', userdetials);
            return response;
        }catch(error){
            showErrorAlert(error);  
        }
    },
    resetPassword: async (token, param) => {
        try {
            const response=await requests.post(`/auth/reset-password/${token}`, param);
            return response;
        }catch(error){
            showErrorAlert(error);  
        }
    },
    sendEmail: async(formData) => {
        console.log("formData", formData);
        try {
            const response=await requests.post(`/auth/send-email`, formData);
            return response;
        }catch(error){
            showErrorAlert(error);  
        }
    },
    saveDiscountList: async (data) => {
    try {
        const response = await requests.post("/auth/save-discount-list", data);
        return response;
    } catch (error) {
            showErrorAlert(error);
            throw error;
        }
    },

  };
  
  export default AuthServices;